import { render, staticRenderFns } from "./i-list-editor.vue?vue&type=template&id=08fa1726&scoped=true&"
import script from "./i-list-editor.vue?vue&type=script&lang=js&"
export * from "./i-list-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fa1726",
  null
  
)

export default component.exports